import { render, staticRenderFns } from "./StorePoster.vue?vue&type=template&id=264e6684&scoped=true&"
import script from "./StorePoster.vue?vue&type=script&lang=js&"
export * from "./StorePoster.vue?vue&type=script&lang=js&"
import style0 from "./StorePoster.vue?vue&type=style&index=0&id=264e6684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e6684",
  null
  
)

export default component.exports